import { gql, MutationHookOptions, useMutation } from "@apollo/client";
import { UserUpdatePasswordMutationVariables } from "../../types";

export const USER_UPDATE_PASSWORD = gql`
  mutation userUpdatePassword($password: String!, $passwordConfirmation: String!, $currentPassword: String) {
    userUpdatePassword(password: $password, passwordConfirmation: $passwordConfirmation, currentPassword: $currentPassword) {
      authenticatable {
        id
      }
    }
  }
`;

export default (
  options?: MutationHookOptions<null, UserUpdatePasswordMutationVariables>
) => {
  return useMutation<null, UserUpdatePasswordMutationVariables>(
    USER_UPDATE_PASSWORD,
    options
  );
};
